module.exports = __webpack_public_path__ + "img/logofull.2ffb281e.svg";